var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointer3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.397,
    height: 86.053,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 152",
    fill: "none",
    strokeWidth: 3,
    d: "M1.233 77.046l62.611-66.46"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u6955\\u5186\\u5F62 30",
    transform: "rotate(-51 38.87 -50.044)",
    fill: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer3);
export default __webpack_public_path__ + "static/media/pointer3.c22579cf734e1b3c.svg";
export { ForwardRef as ReactComponent };